module.exports = __webpack_public_path__ + "img/medlabo_panel2.7658783e.png";